import React from 'react';
import './DeleteAccount.css'; // optional custom styling

function DeleteAccount() {
  return (
    <div className="delete-account-container">
      <div className="delete-account-box">
        <h2>Delete Your Account</h2>
        <p>
          We're sorry to see you go. Please fill out the form below to request deletion of your account and associated data.
        </p>

        <form
          action="https://formspree.io/f/your-form-id" // ← Replace with your actual Formspree form endpoint
          method="POST"
        >
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="your@email.com"
          />

          <label htmlFor="reason">Reason for Deletion (optional)</label>
          <textarea
            id="reason"
            name="reason"
            rows="4"
            placeholder="Let us know why you're leaving..."
          ></textarea>

          <button type="submit">Submit Deletion Request</button>
        </form>
      </div>
    </div>
  );
}

export default DeleteAccount;
